import { Component, HostBinding, Input } from "@angular/core";
import { BoxComponent } from "../box";
import {
  AlignContent,
  AlignItems,
  FlexDirection,
  FlexWrap,
  JustifyContent
} from "./flex-types";

@Component({
  selector: "ta-flexbox",
  template: `
    <ng-content></ng-content>
  `,
  styles: [
    `
      :host {
        display: flex;
      }
    `
  ]
})
export class FlexBoxComponent extends BoxComponent {
  @HostBinding("style.flex-direction")
  @Input()
  flexDirection: FlexDirection | undefined;

  @HostBinding("style.flex-wrap")
  @Input()
  flexWrap: FlexWrap | undefined;

  @HostBinding("style.align-items")
  @Input()
  alignItems: AlignItems | undefined;

  @HostBinding("style.justify-content")
  @Input()
  justifyContent: JustifyContent | undefined;

  @HostBinding("style.align-content")
  @Input()
  alignContent: AlignContent | undefined;
}
